


































































import Vue, { PropType } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import { ValidationObserver } from 'vee-validate';
import IssueCommentService from '@/services/issue-comment.service';
import { IssueCommentEntity } from '@/entities/issue-comment.entity';

@Component<EditBulletinComment>({})
export default class EditBulletinComment extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  IssueCommentPayload: Partial<IssueCommentEntity> = {
    content: null,
    issueId: null,
  };

  @Prop({ type: Boolean })
  value: boolean;

  @Prop({ type: Object as PropType<IssueCommentEntity> })
  comment: IssueCommentEntity;

  @Watch('value')
  async onPropertyChanged() {
    await this.$nextTick();
    this.$refs.form.reset();
    this.IssueCommentPayload.content = this.comment.content;
  }

  async created(): Promise<void> {
    this.IssueCommentPayload.content = this.comment.content;
    this.IssueCommentPayload.issueId = this.comment.issueId;
  }

  @UseService(IssueCommentService)
  service: IssueCommentService;

  async editIssue(): Promise<void> {
    await this.service.updateOne(this.comment.id, this.IssueCommentPayload);
    this.$refs.form.reset();
    this.$emit('input', !this.value);
  }
}
